import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";

const styles = theme => ({
  button: {
    display: "block",
    marginTop: theme.spacing.unit * 2
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  }
});

class SelectList extends React.Component {
  state = {
    age: "",
    open: false
  };

  handleChange = event => {
    this.props.addMethod(event.target.value);
    this.setState({ [event.target.name]: event.target.value });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  render() {
    const { classes } = this.props;

    return (
      <form autoComplete="off">
        <Button className={classes.button} onClick={this.handleOpen}>
          {`Select ${this.props.heading}`}
        </Button>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="demo-controlled-open-select">
            {this.props.heading}
          </InputLabel>
          <Select
            open={this.state.open}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            value={this.state.age}
            onChange={this.handleChange}
            inputProps={{
              name: "age",
              id: "demo-controlled-open-select"
            }}
          >
            {this.props.heading === "Vehicle" && this.props.data.length !== 0
              ? this.props.data.map((item, key) => {
                    return (
                      <MenuItem value={item}>
                        <em>{item.vehicleType}</em>
                      </MenuItem>
                    );
                }, this)
              : null}
          </Select>
        </FormControl>
      </form>
    );
  }
}

SelectList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SelectList);



// WEBPACK FOOTER //
// ./src/admin/SelectList.jsx